var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.5000143051,10.50000103515625C3.5000143051,10.36739103515625,3.5526934,10.24021103515625,3.646461,10.14644103515625L7.79291,6.00000103515625L3.646461,1.8535540351562498C3.5526934,1.7597850351562498,3.5000143051,1.63260803515625,3.5000143051,1.50000003515625C3.5000143051,1.22385803515625,3.723872,1.00000000005625,4.000014,1.00000000005625C4.132623,1.00000000005625,4.2598,1.05267813515625,4.353568,1.14644603515625L8.50001,5.29289103515625Q8.79291,5.58578103515625,8.79291,6.00000103515625Q8.79291,6.41421103515625,8.50001,6.70711103515625L4.353755,10.85336103515625C4.2598,10.94732103515625,4.132623,11.00000103515625,4.000014,11.00000103515625C3.723872,11.00000103515625,3.5000143051,10.77614103515625,3.5000143051,10.50000103515625Z",
    fillRule: "evenodd",
    fill: "#666666",
    fillOpacity: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "media/arrow_right.1c86a35b.svg";
export { ForwardRef as ReactComponent };